import Div from "@jumbo/shared/Div";
import {
    TabContext,
    TabList,
    TabPanel,
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator
} from "@mui/lab";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Tab,
    Typography
} from "@mui/material";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import React from "react";
import { MdClose } from "react-icons/md";

const LeaveCancellationDocumentApproval = ({
    openViewRequest,
    setOpenViewRequest,
    value,
    handleChange,
    requests,
    approvalStatus,
    workflows = [],
    updateHistory
}) => {
    return (
        <Dialog maxWidth="lg" fullWidth open={openViewRequest}>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}>
                <Div sx={{ fontSize: "18px" }}>View Leave Cancellation Request</Div>
                <IconButton onClick={() => setOpenViewRequest(false)}>
                    <MdClose />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
                        <TabList onChange={handleChange} aria-label="Leave Cancellation Tabs">
                            <Tab label="Overview" value="1" sx={{ fontSize: "16px", color: "#000000" }} />
                        </TabList>
                    </Box>

                    <TabPanel value="1">
                        {/* Leave Details */}
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Typography variant="h5">Leave Id</Typography>
                                <Typography variant="h5">Leave Cancellation Id</Typography>
                                <Typography variant="h5">Leave Type</Typography>
                                <Typography variant="h5">Apply Date</Typography>
                                <Typography variant="h5">Cancel Date</Typography>
                                <Typography variant="h5">Reason Of Leave</Typography>
                                <Typography variant="h5">Reason Of Cancellation</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant="h5">: {requests?.Application_Id?.Application_Id}</Typography>
                                <Typography variant="h5">: {requests?.Cancellation_Id}</Typography>
                                <Typography variant="h5">: {requests?.Leavetype_Id?.Leave_Type}</Typography>
                                <Typography variant="h5">: {requests?.Application_Id?.From_Date} to {requests?.Application_Id?.To_Date}</Typography>
                                <Typography variant="h5">: {requests?.Cancel_FromDate} to {requests?.Cancel_ToDate}</Typography>
                                <Typography variant="h5">: {requests?.Application_Id?.ReasonOf_Leave}</Typography>
                                <Typography variant="h5">: {requests?.ReasonOf_Cancelation}</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                {requests.Approved_Flag && requests.Status ? (
                                    <img src="./../../../../../images/StatusFlg/Approved.png" width={150} height={70} />
                                ) : !requests.Approved_Flag && requests.Status ? (
                                    <img src="./../../../../../images/StatusFlg/Rejected.png" width={150} height={70} />
                                ) : (
                                    <img src="./../../../../../images/StatusFlg/Pending.png" width={150} height={70} />
                                )}
                            </Grid>
                        </Grid>
                    </TabPanel>
                </TabContext>
            </DialogContent>
        </Dialog>
    );
};

export default LeaveCancellationDocumentApproval;
